import Bonus from "../bonus/Bonus";
import BonusCollection from "../bonus/BonusCollection";

export default class BonusCollectionSave {
    constructor() {        
    }

    /**
     * @param {BonusCollection} bonusCollection
     * @returns {Object}
     */
    static generateSave(bonusCollection) {
        const saveState = {};

        saveState.availableBonuses = [];
        saveState.activeBonuses = [];
        saveState.prevBonusTurn = bonusCollection.prevBonusTurn;

        for (let i = 0; i < bonusCollection.activeBonuses.length; i++) {
            if (!bonusCollection.activeBonuses[i]) {
                continue;
            }
            saveState.activeBonuses.push(this.generateBonusSave(bonusCollection.activeBonuses[i]));
        }

        for (let i = 0; i < bonusCollection.availableBonuses.length; i++) {
            if (!bonusCollection.availableBonuses[i]) {
                continue;
            }
            saveState.availableBonuses.push(this.generateBonusSave(bonusCollection.availableBonuses[i]));
        }

        return saveState;
    }

    /**
     * @param {BonusCollection} bonusCollection
     * @param {Object} saveState 
     */
    static loadSave(bonusCollection, saveState) {
        if (!saveState) {
            console.log('BonusCollectionSave.loadSave no save state');
            return;
        }
        
        const prevBonusTurn = saveState.prevBonusTurn;
        if (prevBonusTurn) {
            bonusCollection.prevBonusTurn = prevBonusTurn;
        }        

        if (saveState.availableBonuses) {
            for (let i = 0; i < saveState.availableBonuses.length; i++) {
                this.loadBonusSave(bonusCollection, saveState.availableBonuses[i]);
            }
        }

        if (saveState.activeBonuses) {
            for (let i = 0; i < saveState.activeBonuses.length; i++) {
                this.loadBonusSave(bonusCollection, saveState.activeBonuses[i]);
            }
        }
    }

    /**
     * @private
     * @param {Bonus} bonus 
     * @returns {Object}
     */
    static generateBonusSave(bonus) {
        const saveState = {};
        
        saveState.id = bonus.id;
        saveState.activated = bonus.activated;
        saveState.startTurn = bonus.startTurn;
        saveState.activationValue = bonus.getActivationValue();

        return saveState;
    }

    /**
     * @private
     * @param {BonusCollection} bonusCollection 
     * @param {Object} bonusSaveState 
     */
    static loadBonusSave(bonusCollection, bonusSaveState) {
        if (!bonusSaveState) {
            return;
        }

        const id = bonusSaveState.id;
        const activated = bonusSaveState.activated;
        const startTurn = bonusSaveState.startTurn;
        const activationValue = bonusSaveState.activationValue;

        const bonus = bonusCollection.createBonusFromSave(id, activationValue);
        if (!bonus) {
            console.log('BonusCollectionSave.loadBonusSave() no bonus created for: ' + id);
            return;
        }

        bonus.startTurn = startTurn;

        if (!activated) {
            bonusCollection.add(bonus);
        }
        else {
            bonusCollection.addActiveBonusFromSave(bonus);
            bonus.onActivationFromSave();
        }
    }
}